const handleCheckboxBorder = (indeterminate = false, error = false, theme) => {
    if (indeterminate)
        return theme.colors.interactivePrimary01;
    if (error)
        return theme.colors.supportError01;
    return theme.colors.ui03;
};
const handleCheckboxBackground = (disabled = false, indeterminate = false, theme) => {
    if (disabled)
        return theme.colors.disabled01;
    if (indeterminate)
        return theme.colors.interactivePrimary01;
    return theme.colors.ui01;
};
export { handleCheckboxBackground, handleCheckboxBorder };
//# sourceMappingURL=InputCheckbox.helpers.js.map